import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useTermsAndConditionsStyles = makeStyles((theme: Theme) =>
    createStyles({
        pageTitle: {
            marginBottom: theme.spacing(4),
        },
        root: {
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(2, 0),
            },
            padding: theme.spacing(7, 5),
        },
        subtitle: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
        },
        lastUpdate: {
            marginBottom: theme.spacing(6),
        },
        companyName: {
            marginTop: theme.spacing(6),
        },
        inc: {
            marginBottom: theme.spacing(6),
        },
        boldText: {
            fontWeight: 'bold',
        },
    }),
);

export default useTermsAndConditionsStyles;
